<template>
  <div class="container">
    <!-- 顶部区域 -->
    <div class="header">
      <div class="tabs">
        <div
          v-for="tab in tabs"
          :key="tab"
          :class="['tab-item', { active: currentTab === tab }]"
          @click="currentTab = tab"
        >
          {{ tab }}
        </div>
      </div>
      <div class="notice">
        <span
          >请尽快维护历史有产不可售酒店，预计提升月产能
          <span style="color: rgba(219, 1, 1, 1)">2068</span> 间夜</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 左侧区域 -->
      <div class="left-panel">
        <!-- 经营数据 -->
        <div class="data-cards">
          <div
            v-for="(item, index) in businessData"
            :key="index"
            class="data-card"
          >
            <div class="title">
              {{ item.title }}<i class="el-icon-question"></i>
            </div>
            <div class="value">
              {{ item.value }}
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="compare">
              较上周同期
              <span
                :class="[
                  'increase',
                  {
                    'increase-up': item.rate.includes('↑'),
                    'increase-down': item.rate.includes('↓'),
                  },
                ]"
              >
                ↓{{ item.rate }}
              </span>
            </div>
          </div>
        </div>

        <!-- 待处理订单 -->
        <div class="pending-orders">
          <div class="order-header">
            <div class="left">
              <span
                ><span style="font-weight: 600; font-size: 16px"
                  >待处理订单</span
                >
                <span style="color: #529efc; font-weight: 600">0单</span
                >&nbsp;></span
              >
              <span class="stats">今日新单 0</span>
              <span class="stats">今日入住 0</span>
              <span class="stats">订单事件 230</span>
            </div>
            <!-- <span class="reminder">提醒设置</span> -->
          </div>
          <el-table
            :data="[]"
            height="400"
            border
            :header-cell-style="{ background: '#f5f7fa' }"
          >
            <el-table-column prop="orderNo" label="订单号"></el-table-column>
            <el-table-column prop="roomType" label="房型"></el-table-column>
            <el-table-column prop="date" label="住/离日期"></el-table-column>
            <el-table-column prop="guest" label="入住人"></el-table-column>
            <el-table-column prop="price" label="总价"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini">处理</el-button>
              </template>
            </el-table-column>
            <template #empty>
              <div style="text-align: center">
                <el-empty description="暂无待处理订单"></el-empty>
                <!-- <div>暂无待处理订单</div> -->
              </div>
            </template>
          </el-table>
        </div>

        <!-- 房态维护 -->
        <div class="room-status">
          <div class="title" style="font-weight: 600; font-size: 16px">
            五天房态维护 >
          </div>
          <el-table
            border
            :header-cell-style="{ background: '#f5f7fa' }"
            :data="roomTableData"
            style="width: 100%"
          >
            <el-table-column
              prop="roomType"
              align="center"
              label="房型/产品"
              width="150"
            ></el-table-column>
            <el-table-column label="剩余 | 已售" width="150" :align="`center`">
              <template #default="scope">
                <div>剩总量 | 剩保留房</div>
                <div>已售</div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              v-for="day in days"
              :key="day"
              :label="day"
            >
              <template #default="scope">
                <div>未设置库存</div>
                <el-switch
                  v-model="roomStatus[scope.row.roomType][day]"
                ></el-switch>
              </template>
            </el-table-column>
          </el-table>
          <div class="expand-more">
            <span>展开查询更多</span>
          </div>
        </div>
      </div>

      <!-- 右侧区域 -->
      <div class="right-panel">
        <!-- 待办事项 -->
        <div class="todo-list">
          <div
            class="title"
            style="width: 100%; justify-content: space-between"
          >
            待办事项
            <span class="all">全部</span>
          </div>
          <div class="todo-items" style="height: 100vh; overflow-y: auto">
            <div v-for="(item, index) in 20" :key="index" class="todo-item">
              <div class="left-content">
                <div>
                  <div class="hotel">深圳南山大道希尔顿花园酒店</div>
                  <div class="task">
                    <span
                      class="task-label"
                      style="
                        background: rgb(64 158 255 / 79%);
                        color: #fff;
                        margin-right: 5px;
                        padding: 2px 4px;
                        border-radius: 2px;
                        white-space: nowrap;
                      "
                    >
                      <i class="el-icon-warning" style="color: #fff"></i>
                      房态维护提醒</span
                    >
                    <span class="room-types"
                      >花园大床房、花园双床房、高级大床房、高级双床房、豪华大床房</span
                    >
                  </div>
                </div>
              </div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <!-- 快速查询 -->
        <!-- <div class="quick-search">
          <el-input placeholder="请输入客人姓名/订单号" v-model="searchKey">
            <el-button slot="append" type="primary">查询</el-button>
          </el-input>
        </div> -->

        <!-- 重要通知 -->
        <!-- <div class="notices">
          <div class="title">重要通知</div>
          <div
            v-for="(notice, index) in notices"
            :key="index"
            class="notice-item"
          >
            【重要】{{ notice.title }}（{{ notice.date }}）
          </div>
        </div> -->

        <!-- 广告 -->
        <!-- <div class="ad">
          <div class="ad-content">
            <div class="left">
              <h3>智能配送机器人</h3>
              <p class="price">惊爆价 ¥19800</p>
              <p>自动开门 | 紫外消毒</p>
              <el-button type="text">查看详情 ></el-button>
              <p class="tel">400-123-4567</p>
            </div>
            <div class="right">
              <img src="qrcode-placeholder.png" alt="二维码" />
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      roomTableData: [
        { roomType: "每日汇总" },
        { roomType: "都市大床房" },
        // 其他房型
      ],
      currentTab: "昨日经营",
      tabs: ["昨日经营", "酒店数据"],
      businessData: [
        { title: "订单量", value: "186 单", rate: "126.83%" },
        { title: "间夜量", value: "264 间夜", rate: "149.06%" },
        { title: "销售额", value: "68969 元", rate: "74.67%" },
        { title: "平均房价", value: "371 元", rate: "23%" },
      ],
      roomStatus: {
        每日汇总: { 今天: false, "10号": false },
        都市大床房: { 今天: false, "10号": false },
      },
      notices: [{ title: "DID 电话使用规范", date: "2025-04-18" }],
      searchKey: "",
    };
  },
  computed: {
    roomTypes() {
      return Object.keys(this.roomStatus);
    },
    days() {
      return ["今天", "10号", "11号", "12号", "13号"];
    },
  },
};
</script>
  
<style scoped>
.container {
  background: #fff;
  height: 100vh;
  overflow: auto;
}

.room-status {
  margin-top: 20px;
  border: 1px solid #eee;
  padding: 10px;
}

.expand-more {
  text-align: center;
  padding: 10px;
  color: #999;
  font-size: 12px;
  cursor: pointer;
}

.left-panel {
  flex: 3;
  background: #fff; /* 确保左侧面板背景为白色 */
}

.data-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
  background: #fff; /* 确保经营数据区域背景为白色 */
}

.data-card {
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff; /* 确保数据卡片背景为白色 */
}

.pending-orders {
  margin-top: 20px;
  background: #fff; /* 确保待处理订单区域背景为白色 */
}

.room-status .status-table {
  display: grid;
  grid-template-columns: 150px repeat(5, 1fr);
  border: 1px solid #ebeef5;
  background: #fff; /* 确保房态表格背景为白色 */
}
.title {
  padding: 0px;
  font-size: 14px;
}
.header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #eee;
}
.increase-up {
  color: #f56c6c; /* 红色 */
}

.increase-down {
  color: #67c23a; /* 绿色 */
}
.tabs {
  display: flex;
  gap: 30px;
}
.left {
  display: flex;
  align-items: center;
}
.stats {
  display: flex;
  align-items: center;
  padding: 6px 6px;
  border: 1px solid rgba(51, 51, 51, 0.14);
  border-radius: 2px;
  margin-right: 8px;
  font-weight: 500;
  font-size: 12px;
  color: #333;
  position: relative;
  left: 15px;
}
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  background-color: #ebeef5 !important;
}
span.reminder {
  font-weight: 400;
  font-size: 12px;
}

.tab-item {
  cursor: pointer;
  padding-bottom: 5px;
}

.tab-item.active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.main-content {
  display: flex;
  padding: 20px;
  gap: 20px;
}

.left-panel {
  flex: 3;
}

.right-panel {
  flex: 1;
  min-width: 300px;
}

.data-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.data-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.data-card .value {
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #333;
  font-weight: 700;
}

.order-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
}
.el-table tr {
  background: #f6f7fa;
}
.compare {
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #999;
}

.data-card .increase {
  color: #67c23a;
}

.pending-orders {
  margin-top: 20px;
  border: 1px solid #eee;
}

.room-status .status-table {
  display: grid;
  grid-template-columns: 150px repeat(5, 1fr);
  border: 1px solid #ebeef5;
}
.notice {
  font-weight: 400;
  font-size: 14px;
  color: #999;
}
.todo-item,
.notice-item {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.ad {
  margin-top: 20px;
  padding: 15px;
  background: #f5f7fa;
}

.ad .ad-content {
  display: flex;
  justify-content: space-between;
}
.todo-list {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
}

.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.all {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
}

.todo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.left-content {
  display: flex;
  align-items: center;
}

.hotel {
  font-size: 12px;
  font-weight: 500;
  color: #333;
}

.task {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.room-types {
  display: -webkit-box;
  -webkit-line-clamp: 1; /* 限制行数为2 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #999;
}

.el-icon-arrow-right {
  color: #999;
  cursor: pointer;
}
</style>
  


// WEBPACK FOOTER //
// src/components/home/bodyContent.vue